module.exports = __webpack_public_path__ + "img/empty@2x.e299187d.png";